import { Component, OnInit } from '@angular/core';
import { AppEnviroment } from 'src/app/model/app-enviroment';

@Component({
  selector: 'app-required-field-msg',
  templateUrl: './required-field-msg.component.html',
  styleUrls: ['./required-field-msg.component.scss']
})
export class RequiredFieldMsgComponent implements OnInit {

  msg;
  constructor() {
    this.msg =AppEnviroment.Translate.instant('commonFields.requiredFieldMsg')
  }

  ngOnInit() {
  }

}
